// web component 业务组件库，本身为 loader 按需加载，使用时才会动态加载和注册组件，所以需要用的地方直接使用即可
// gitlab: https://code.byted.org/ad/byted-web-components/tree/master/ui/wc-business-ui
// @ts-ignore init
import { defineCustomElementBytedWcNameTemplateTitle } from '@byted/wc-business-ui/dist/components';

/**
 * 对 web component 传复杂类型的指令封装（对象/函数）
 * 因为在为 html 元素 web component 传输 props 时，会使用 toString parse，使得对象类型的数据变为 "[Object Object]"
 * 这个在 vue3 版本后已支持（检查元素时，元素上不展示该 attr），在未升级 vue3 前，有两种做法：
 * 1. JSON.stringify 转换后传输，缺点是 wc 组件需要适配，元素上也会有数据的展示，不够优雅
 * 2. 获取到元素后，使用【el.data = obj】的形式传递复杂类型，响应到 data 改变时再重新赋值
 * 该指令用于封装动态为 el 设置属性的逻辑
 */
export const wcBindDirective = function (el, binding) {
  // v-wc-bind="{k1: v1, k2: v2, event1: handleEvent1}"
  const { value } = binding;
  const valueKeys = Object.keys(value || {});

  if (valueKeys.length > 0) {
    valueKeys.forEach((key) => {
      el[key] = value[key];
    });
  }
};

export const installWc = (Vue) => {
  Vue.directive('wc-bind', wcBindDirective);
};

defineCustomElementBytedWcNameTemplateTitle();
